import { shallowEqual } from "react-redux";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../model/index.js";
function useEquipmentItems(carId) {
  const equipments = useAppSelector((state) => {
    if (!carId) {
      return [];
    }
    const expandedEquipments = selectors.selectById(state.equipments, carId);
    return (expandedEquipments == null ? void 0 : expandedEquipments.groups) || [];
  }, shallowEqual);
  return equipments;
}
export {
  useEquipmentItems
};
